import React from 'react';
import { isEmpty, map, fromPairs, find } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { SIZES } from 'constants/common';
import { Form } from 'modules/form';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { wellConnectOptIn as WellConnectOptIn } from 'ui/views/widgets/wellConnectOptIn';
 *
 * // render
 * <WellConnectOptIn propName='propValue'/>
 */
export const wellConnectOptIn = ( props ) => {
    const infoSection = props.infoSection;
    const optInSection = props.optInSection;

    const okButton = find( props.actions, { name: 'ok' } );

    return (
        <div className='ui-well-connect-opt-in'>

            {/* header */}
			<div className='ui-well-connect-opt-in__header'>

				{ /* title for the modal */ }
				<div className='ui-well-connect-opt-in__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-well-connect-opt-in__header__close'
					onClick={ props.onCancelClick }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>

            {/* body */}
			<div className='ui-well-connect-opt-in__body'>

                {/* info section */}
                <div className='ui-well-connect-opt-in__body__info-section'>

                    {/* title */}
                    <div className='ui-well-connect-opt-in__body__info-section__title'>
                        { getLabel( infoSection.title ) }
                    </div>

                    {/* list */}
                    <div className='ui-well-connect-opt-in__body__info-section__items'>
                        {
                            map( infoSection.items, ( item, index ) => {
                                return (
                                    <div key={ index } className='ui-well-connect-opt-in__body__info-section__items__item'>
                                        <div className='ui-well-connect-opt-in__body__info-section__items__item__dot'></div>
                                        <div className='ui-well-connect-opt-in__body__info-section__items__item__text'>
                                            { getLabel( item ) }
                                        </div>
                                    </div>
                                );
                            } )
                        }
                    </div>
                    <div className='ui-well-connect-opt-in__body__info-section__title '>
                        { getLabel( infoSection.healthDyneAffiliates ) }
                    </div>

                      <div className='ui-well-connect-opt-in__body__info-section__title'>
                        { getLabel( infoSection.contactNumberMessage ) }
                    </div>
                </div>

                {/* opt-in section */}
                {
                    ! isEmpty( optInSection ) ? (
                        <div className='ui-well-connect-opt-in__body__opt-in-section'>

                            {/* title */}
                            <div className='ui-well-connect-opt-in__body__opt-in-section__title'>
                                { getLabel( optInSection.title ) }
                            </div>

                            <Form
                                fields={ fromPairs( map( [ optInSection.phoneField ], ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                                isValid={ false }
                                mode='form'
                                onSubmit={ ( { values, isValid } ) => {
                                    if( isValid ) {
                                        props.onFormSubmit( values );
                                    }
                                } }
                            >
                                { ( { fields, values, errors, onChange, onSumbit } = {} ) => {
                                    return (
                                        <form
                                            onSubmit={ onSumbit }
                                            className='ui-well-connect-opt-in__body__opt-in-section__form'
                                        >
                                            { /* fields */ }
                                            { map( fields, ( field ) => {
            
                                                return (
                                                    <field.view
                                                        className='ui-well-connect-opt-in__body__opt-in-section__form__field'
                                                        key={ field.name }
                                                        name={ field.name }
                                                        required={ field.required }
                                                        placeholder={ field.placeholder }
                                                        showLabel={ false }
                                                        onChange={ onChange }
                                                        value={ values[ field.name ] }
                                                        error={ errors[ field.name ] }
                                                        mask={ field.mask }
                                                    />
                                                );
                                            } ) }

                                            {/* consent */}
                                            <div className='ui-well-connect-opt-in__body__opt-in-section__form__consent'>

                                                {/* checkbox */}
                                                <div
                                                    className='ui-well-connect-opt-in__body__opt-in-section__form__consent__checkbox'
                                                    onClick={ props.onConsentClick }
                                                >
                                                    <Checkbox
                                                        size='xs'
                                                        value={ props.consent }
                                                        name='consent'
                                                    />
                                                </div>

                                                {/* description */}
                                                <div className='ui-well-connect-opt-in__body__opt-in-section__form__consent__description'>
                                                    { getLabel( optInSection.consentDescription ) }
                                                </div>
                                            </div>
                                            
                                            {/* actions */}
                                            <div className='ui-well-connect-opt-in__body__opt-in-section__form__actions'>
                                                { map( props.actions, ( action ) => {
                                                    const actionName = action.name;

                                                    return (
                                                        <Button
                                                            className='ui-well-connect-opt-in__body__opt-in-section__form__actions__action'
                                                            key={ actionName }
                                                            id= { actionName }
                                                            type= { 'cancel' !== actionName ? 'submit' : 'button' }
                                                            title={ action.title }
                                                            size={ SIZES.LARGE }
                                                            outline={ 'cancel' === actionName ? true: false }
                                                            disabled={ 'cancel' !== action.name ? !props.consent : false }
                                                            onClick = { 'cancel' === actionName ?  props.onCancelClick : null }
                                                        />
                                                    );
                                                } ) }
                                            </div>
                                        </form>
                                    );
                                } }
                            </Form>
                        </div>
                    ) : null
                }

                {/* ok button (only in case of 'more details' form) */}
                {
                    isEmpty( optInSection ) ? (
                        <div className='ui-well-connect-opt-in__body__ok-button-wrapper'>
                            <Button
                                className='ui-well-connect-opt-in__body__ok-button-wrapper__button'
                                id={ okButton.name }
                                title={ okButton.title }
                                size={ SIZES.LARGE }
                                onClick={ props.onCancelClick }
                            />
                        </div>
                    ) : null
                }
            </div>
		</div>
    );
};

// set display name
wellConnectOptIn.displayName = 'wellConnectOptIn';

// set default props
wellConnectOptIn.defaultProps = {};

// prop types
wellConnectOptIn.propTypes = {};
